export default __webpack_public_path__ + "static/media/ProductsIcon.813d99fb.svg";